/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAttachMessageShipmentInput = {
    clientMutationId?: string | null;
    messageSlugs: Array<string>;
    shipmentSlug: string;
};
export type MessageListAttachShipmentMutationVariables = {
    input: infoAttachMessageShipmentInput;
};
export type MessageListAttachShipmentMutationResponse = {
    readonly infoAttachMessageShipment: {
        readonly clientMutationId: string | null;
    } | null;
};
export type MessageListAttachShipmentMutation = {
    readonly response: MessageListAttachShipmentMutationResponse;
    readonly variables: MessageListAttachShipmentMutationVariables;
};



/*
mutation MessageListAttachShipmentMutation(
  $input: infoAttachMessageShipmentInput!
) {
  infoAttachMessageShipment(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoAttachMessageShipmentPayload",
    "kind": "LinkedField",
    "name": "infoAttachMessageShipment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageListAttachShipmentMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MessageListAttachShipmentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b4bbc82938c0f0ba13ffdec91bb47e3",
    "id": null,
    "metadata": {},
    "name": "MessageListAttachShipmentMutation",
    "operationKind": "mutation",
    "text": "mutation MessageListAttachShipmentMutation(\n  $input: infoAttachMessageShipmentInput!\n) {\n  infoAttachMessageShipment(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '277b73d7d9ebf8bb4f165b16d98e2642';
export default node;
